import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Top-level project fields of the block project-power-company-communication ("EVU
 * Kommunikation") with their payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectPowerCompanyCommunicationInput`; `createPayload` reuses the types.
 */
export const PROJECT_POWER_COMPANY_COMMUNICATION_FIELD_TYPES = {
  netRegistrationSentAt: 'date',
  operationRegistrationSentAt: 'date',
  injectionConfirmationReceivedAt: 'date',
  completionMessageSentAt: 'date',
  powerCompanyClearanceAt: 'date',
  powerCompanyProjectNumber: 'string',
  powerCompanyProjectNumber2: 'string',
  powerCompanyProjectNumber3: 'string',
  powerCompanyDescription: 'string',
};

export const PROJECT_POWER_COMPANY_COMMUNICATION_INPUT_FIELDS = Object.keys(
  PROJECT_POWER_COMPANY_COMMUNICATION_FIELD_TYPES
);

/**
 * `ProjectPowerCompanyCommunicationInput` from the block object. Every field is sent, missing
 * values as null: the API keeps an omitted field, only null clears it.
 */
export const toProjectPowerCompanyCommunicationInput = (project) =>
  preparePayloadForGraphQL(
    Object.fromEntries(
      PROJECT_POWER_COMPANY_COMMUNICATION_INPUT_FIELDS.map((field) => [
        field,
        project[field] ?? null,
      ])
    ),
    PROJECT_POWER_COMPANY_COMMUNICATION_FIELD_TYPES
  );
